import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 25",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M.75 23.318h22.5",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m16.616 2.561 5.74 5.508c.562.54.878 1.273.878 2.037s-.316 1.497-.879 2.037l-6.486 6.226c-1.688 1.62-3.977 2.531-6.364 2.531s-4.676-.91-6.364-2.53l-1.5-1.44a2.8 2.8 0 0 1 0-4.073L12.374 2.561c1.172-1.124 3.07-1.124 4.242 0Z",
			stroke: "#262626",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			clipRule: "evenodd"
		})
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2024%2025%22%3E%3Cpath%20d%3D%22M.75%2023.318h22.5%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%2F%3E%3Cpath%20d%3D%22m16.616%202.561%205.74%205.508c.562.54.878%201.273.878%202.037s-.316%201.497-.879%202.037l-6.486%206.226c-1.688%201.62-3.977%202.531-6.364%202.531s-4.676-.91-6.364-2.53l-1.5-1.44a2.8%202.8%200%200%201%200-4.073L12.374%202.561c1.172-1.124%203.07-1.124%204.242%200Z%22%20stroke%3D%22%23262626%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20stroke-width%3D%221.5%22%20clip-rule%3D%22evenodd%22%2F%3E%3C%2Fsvg%3E";
